module.exports = __webpack_public_path__ + "daisy1.e65f97c.jpg";